import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderProfileService {
  isLogged$ = new BehaviorSubject<boolean>(false);
  denyAccess$ = new BehaviorSubject<boolean>(false);
  hasRoutes$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  onLogged() {
    this.isLogged$.next(true);
  }

  denyAccess() {
    this.denyAccess$.next(true);
  }

  onRouting() {
    this.hasRoutes$.next(true);
  }
}
